export default "__VITE_ASSET__4651d109__"